module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero13.png?70179b18";